import { ActionButtonType } from '../../PdpProductProvider/types';
import {
  ADD_TO_CART_LABEL,
  NOTIFY_ME_LABEL,
  PRE_ORDER_LABEL,
  VIEW_LABEL,
  CHECK_AVAILABILITY_LABEL,
} from '../constants';

export const getProductCardActionLabel = (buttonType: string) => {
  switch (buttonType) {
    case ActionButtonType.NotifyMe:
      return NOTIFY_ME_LABEL;
    case ActionButtonType.PreOrder:
      return PRE_ORDER_LABEL;
    case ActionButtonType.View:
      return VIEW_LABEL;
    case ActionButtonType.CheckAvailability:
      return CHECK_AVAILABILITY_LABEL;
    default:
      return ADD_TO_CART_LABEL;
  }
};
